import { Injectable } from '@angular/core';
import { Image } from '@app/shared/models/image.model';
import { Observable, of } from 'rxjs';
import { ImageService } from '@app/shared/helpers/image.service';
import { tap } from 'rxjs/operators';
import { AssetService } from '@core/services/asset.service';

@Injectable()
export class AssetImagesStoreService {
    private assetImages: Map<number, Image>;

    constructor(private assetService: AssetService, private imageService: ImageService) {
        this.assetImages = new Map<number, Image>();
    }

    clear() {
        this.assetImages.clear();
    }

    getImage(assetId: number): Observable<Image> {
        const image = this.assetImages.get(assetId);

        if (image) {
            return of(image);
        } else {
            return this.imageService
                .handleBlobObservable(
                    this.assetService.getImage(assetId),
                    'precision_manufacturing'
                )
                .pipe(tap((result) => this.assetImages.set(assetId, result)));
        }
    }
}
